// src/components/ProtectedRoute.js

import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "context/AuthContext";

/**
 * Componente de ruta protegida que verifica la autenticación con Firebase
 * Redirige al login solo si realmente no hay usuario autenticado
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Pantalla neutra: no usar DashboardLayout ni skeletons (parecían panel con sesión).
    return (
      <Box
        role="status"
        aria-live="polite"
        aria-label="Comprobando sesión"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <CircularProgress color="info" />
      </Box>
    );
  }

  // Si no hay usuario autenticado, redirigir al login con la ruta original
  if (!user) {
    // Guardar también en sessionStorage por si el state se pierde al navegar
    try {
      sessionStorage.setItem("auth_redirect_from", location.pathname);
    } catch (e) {
      // ignorar si sessionStorage no está disponible
    }
    return (
      <Navigate 
        to="/authentication/sign-in" 
        state={{ from: location.pathname }}
        replace 
      />
    );
  }

  // Si hay usuario autenticado, renderizar el componente hijo
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

